export default {
  metaTitle: 'Product Reviews',
  pageTitle: 'Store Review Management',
  all: 'All',
  unreplied: 'Unreplied',
  replied: 'Replied',
  sku: 'Sku#',
  reviewDetails: 'Review details',
  orderRating: 'Order (parcel) Rating',
  deliverySpeed: 'Delivery speed',
  Minute: '分',
  sellerService: 'Seller Service',
  deliveryService: 'Delivery Service',
  productRating: 'Product rating',
  Evaluation: 'Content of commodity evaluation',
  replyContent: 'Reply content',
  inputPlaceholder1: 'Please input your reply',
  SKU: 'SKU#',
  listingId: 'Listing ID',
  commentId: 'Comment ID',
  title: 'Title',
  userId: 'User ID',
  reviewDate: 'Review Date',
  score: 'Score',
  withPicture: 'With Picture',
  operation: 'Operation',
  checkDetails: 'Check Details',
  selectSku_Listing: '请选择Sku或Listing！',
  cannotEmpty: 'Content cannot be empty',
  moreThan_200word: '回复不能超过200个字符！'
}
